import React from "react";
import { DeleteModal } from "../../../Common/DeleteModal";
import { BannerTable } from "../../../Common/BannerTable";
import { templateDefaultValue } from "@constants/template";
import LanguageTable from "../../../Common/LanguageTable";

export function OffersSection() {
    return (
        <div className="banner-container">
            <section className="text-section">
                <div className="banner-images">
                    <BannerTable
                        section={"Offres"}
                        path={[
                            "template",
                            "Application",
                            "LaindingPage",
                            "Default",
                            "Offres",
                            "Pubs",
                        ]}
                        redirection={true}
                    />
                </div>
                <LanguageTable
                    path={["Application", "LaindingPage", "Default", "Offres"]}
                    fields={[
                        {
                            key: "Title",
                            label: "Title",
                            placeholder: "Enter the Title",
                        },
                    ]}
                    defaultTexts={
                        templateDefaultValue.Application.LaindingPage.Default
                            .Offres
                    }
                    sectionTitle="Title"
                />
                <DeleteModal section="Offres" />
            </section>
        </div>
    );
}
